import { useState } from "react";
import { Form } from "react-bootstrap";
import "./choiceLimits.scss";

/**
 * The choice limits of an option group (talabatk/api docs/option-choices.md):
 * the fewest and the most options that a customer chooses, and how many of
 * them are free. The API checks the numbers and answers with a sentence.
 *
 * The four group forms (add and edit a product, add and edit a general group)
 * use this one component.
 */

const FIELDS = [
    { key: "min_choices", label: "الحد الأدنى", help: "0: اختياري. 1 أو أكثر: مطلوب." },
    { key: "max_choices", label: "الحد الأقصى", help: "فارغ: بلا حد. للخيار الواحد: فارغ أو 1." },
    { key: "free_choices", label: "عدد المجاني", help: "الأرخص من اختيارات الزبون." },
];

/** The values of a saved group, or the defaults for a new one. */
export const limitsOf = (group) => ({
    min_choices: group?.min_choices ?? 0,
    max_choices: group?.max_choices ?? "",
    free_choices: group?.free_choices ?? 0,
});

const ChoiceLimits = ({ group, onChange }) => {
    const [values, setValues] = useState(() => limitsOf(group));

    const change = (key) => (event) => {
        const next = { ...values, [key]: event.target.value };
        setValues(next);
        onChange(next);
    };

    return (
        <div className="choice-limits">
            {FIELDS.map((field) => (
                <Form.Group key={field.key} className="choice-limits__field">
                    <Form.Label>{field.label}</Form.Label>
                    <Form.Control
                        type="number"
                        inputMode="numeric"
                        min={field.key === "max_choices" ? 1 : 0}
                        max={50}
                        step={1}
                        value={values[field.key]}
                        onChange={change(field.key)}
                    />
                    <Form.Text muted>{field.help}</Form.Text>
                </Form.Group>
            ))}
        </div>
    );
};

export default ChoiceLimits;
